import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { isValidNumber } from 'libphonenumber-js';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor() { }

  static isDefined(obj: any): boolean {
    return obj !== undefined && obj !== null;
  }

  public static getFileFormat(ext: string) {
    switch (ext) {
      case 'PDF':
        return 'PDF';
      case 'DOC':
      case 'DOCX':
        return 'WORD_DOCUMENT';
      case 'JPEG':
      case 'JPG':
      case 'PNG':
        return 'IMAGE';
    }
  }

  public static getAge(birthDate) {
    let age = { name: 'Year(s)', value: moment().diff(birthDate, 'years') };
    if (age.value === 0) {
      age = { name: 'Month(s)', value: moment().diff(birthDate, 'months') };
    }
    if (age.value === 0) {
      age = { name: 'Week(s)', value: moment().diff(birthDate, 'weeks') };
    }
    if (age.value === 0) {
      age = { name: 'Day(s)', value: moment().diff(birthDate, 'days') };
    }
    return age;
  }

  public static formatDate(date: Date, format: DateFormats) {
    if (!date) return null;
    return moment(date).format(format);
  }

  public static dateDifference(firstDate: Date, lastDate: Date) {
    return moment(firstDate).diff(moment(lastDate));
  }

  public static isValidMsisdn(phone: string) {
    return (
      //isValidNumber(phone.substring(1, phone.length - 1), '001') ||
      isValidNumber(phone, 'ZW') ||
      isValidNumber(phone, 'BI') ||
      isValidNumber(phone, 'LS')
    );
  }
}

export type DateFormats =
  | 'DD-MM-YYYY'
  |  'DDMMYYYY'
  | 'DD/MM/YYYY'
  | 'ddMMyyyy'
  | 'YYYY-MM-DD'
  | 'DD-MM-YYYYTHH:mm:ss';
